import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { Box, Stack } from "@mui/material";
import { useHunterLicenseSharesQuery } from "Api/Queries/Hunter/useHunterLicenseSharesQuery";
import { useHunterMerchantsQuery } from "Api/Queries/Hunter/useHunterMerchantsQuery";
import { HunterDetailMerchantsTable } from "Components/Hunter/HuntersOverview/HunterDetailMerchantsTable";
import { SharedMerchantsTable } from "Components/Hunter/Merchants/MerchantsList/SharedMerchantsTable";
import {
  MerchantRegistrationSource,
  MerchantStatus,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Merchants.ListPage;

type Props = {
  userID: number;
};

export const HunterDetailMerchants = ({ userID }: Props) => {
  const { t } = useResource();
  const { data: merchantsData, isLoading: isLoadingMerchants } =
    useHunterMerchantsQuery(userID);
  const { data: sharedMerchantsData, isLoading: isLoadingSharedMerchants } =
    useHunterLicenseSharesQuery(userID);

  const merchants = merchantsData?.items ?? [];
  const filteredMerchants = merchants.filter(
    ({ merchantStatus, registrationSource }) =>
      merchantStatus !== MerchantStatus.InDraft &&
      !(
        merchantStatus === MerchantStatus.Onboarding &&
        registrationSource === MerchantRegistrationSource.SelfRegistered
      ),
  );

  const sharedMerchants = sharedMerchantsData?.items ?? [];

  const hasMerchants = filteredMerchants.length > 0 || isLoadingMerchants;
  const hasSharedMerchants =
    sharedMerchants.length > 0 || isLoadingSharedMerchants;

  if (!hasMerchants && !hasSharedMerchants) {
    return null;
  }

  return (
    <Stack gap={2}>
      {hasMerchants && (
        <Box display="grid" alignItems="start">
          <HunterDetailMerchantsTable
            isLoading={isLoadingMerchants}
            data={filteredMerchants}
            title={
              <Box component="span" display="flex" alignItems="center" gap={1}>
                <StorefrontOutlinedIcon />
                {t(RESOURCES.MerchantsTitle)}
              </Box>
            }
          />
        </Box>
      )}
      {hasSharedMerchants && (
        <Box display="grid" alignItems="start">
          <SharedMerchantsTable
            isLoading={isLoadingSharedMerchants}
            data={sharedMerchants}
            enableLicenseGrouping={false}
            density="compact"
            title={
              <Box component="span" display="flex" alignItems="center" gap={1}>
                <SupervisorAccountOutlinedIcon />
                {t(RESOURCES.SharedMerchantsTitle)}
              </Box>
            }
          />
        </Box>
      )}
    </Stack>
  );
};
